<template>
<div class="wrapper">
    
    <navsearch></navsearch>
    <van-tabs v-model="tabCurrentIndex" @change="tabchange">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
            <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
              <div class="nnlist"  ref="container">

                <van-list v-model="navitem.loaded" :finished="navitem.loadingType=='nomore'?true:false" :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'" @load="loadData">

                    <div v-for="(item,index) in navitem.orderList" :key="index">
                        <div class="order-item"  @click="godetail(item)">
                            <div class="order-item-sl">
                                <div class="item-header">
                                    <span class="item-header-left">订单:{{item.tid}}</span>
                                    <span class="item-header-right right-tit">{{item.splitOrderState==1?item.deliveryStatus==1?'部分发货':item.orderStatusEnumName:item.orderStatusEnumName}}</span>
                                </div>
                                <div class="item-list">
                                    <div v-for="(product,i) in item.tradeDetails" :key="i">
                                        <comtradecard :product='product' :isIntegralTrade="item.isIntegralTrade"/>
                                    </div>
                                </div>
                                <div class="item-price">
                                    <van-tag type="primary" v-if="item.orderMoudleType==3">礼品单</van-tag>
                                </div>
                                <div class="item-price">
                                    <div>
                                        <span class="price-left">{{item.isIntegralTrade?'总积分'+item.payIntegral:'总价￥'+item.totalFee}}</span>
                                        <span>{{item.isIntegralTrade?'实付积分'+item.payIntegral:'实付款￥'+item.payment}}</span>
                                    </div>
                                </div>
                                <div class="item-footer">
                                    <div v-if="item.orderStatusEnum==0">
                                            <van-button size="small" color="#ff9970" plain round type="primary" @click.stop="oncepay(item)">付款</van-button>
                                            <van-button size="small" color="#ff9970" plain round type="primary" @click.stop="cancelOrder(item)">取消订单</van-button>
                                    </div>
                                    <div v-if="!systemsetting.isDisabledRefound && item.orderMoudleType==0 && (item.orderStatusEnum==1&&item.buyerRefundStatus==0 && item.tranferOrderState==0 && !item.isIntegralTrade)">
                                        <van-button size="small" color="#ff9970" plain round type="primary" @click.stop="sqtk(item)">申请退款</van-button>
                                    </div>
                                    <div v-if="item.orderStatusEnum==2&&item.buyerRefundStatus==0">
                                        <van-button size="small" color="#ff9970" v-if="item.deliveryStatus==2" plain round type="primary" @click.stop="confirmsend(item)">确认收货</van-button>
                                        <!-- <van-button size="small" type="primary"  v-if="!systemsetting.isDisabledOrderReturn" @click.stop="sqtk(item)">申请退款</van-button> -->
                                        <van-button size="small" color="#ff9970" plain round type="primary" @click.stop="logisticinfo(item.tid)">快递轨迹</van-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <van-cell-group class="order-item" @click="godetail(item)">
                            <van-panel :title="'订单：'+item.tid" :status="item.orderStatusEnumName">
                                <div slot="header">
                                    <van-cell class="title" :title="'订单：'+item.tid" :value="item.splitOrderState==1?item.deliveryStatus==1?'部分发货':item.orderStatusEnumName:item.orderStatusEnumName" />
                                </div>
                                <div>
                                    <div>
                                        <div v-for="(product,i) in item.tradeDetails" :key="i">
                                            <trade-card :product='product' />
                                        </div>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="total">总价：￥{{item.payment}}</div>
                                   
                                </div>
                            </van-panel>
                        </van-cell-group> -->

                    </div>

                </van-list>
              </div>
            </van-tab>
        <!-- </van-pull-refresh> -->
    </van-tabs>

</div>
</template>

<script>
import request from "@/config/ajax";
export default {
    components: {},
    data() {
        return {
            isLoading: false,
            refreshing: false,
            tabCurrentIndex: 0,
            fixed: false,
            navList: [{
                    state: 0,
                    text: '全部',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "orderStateList": [],
                        "productSku": "",
                        "refundStatus": -1,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 1,
                    text: '待付款',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "orderStateList": [0],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 2,
                    text: '待发货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "orderStateList": [1],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 3,
                    text: '待收货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "orderStateList": [2],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 4,
                    text: '待评价',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "orderStateList": [3],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                }
                // {
                //     state: 5,
                //     text: '已取消',
                //     loadingType: 'more',
                //     loaded:false,
                //     getparams: {
                //         "tid": "",
                //         "name": "",
                //         "sku": "",
                //         "orderStateList": [5],
                //         "productSku": "",
                //         "sorting": "",
                //         "maxResultCount": 10,
                //         "skipCount": 0
                //     },
                //     orderList: []
                // }
            ],
            systemsetting: undefined,
            paydto: {
                tid: ''
            },
            contentStartY:0
        }
    },
    created() {

        request.post('/api/services/app/SystemSettingFunction/QueryModel').then(x => {
            this.systemsetting = x.result;
        })
        var option = this.$route.query;

        if (option.state) {
            this.tabCurrentIndex = Number.parseInt(option.state);
        }
        this.loadData();
    },
    methods: {
        tabchange() {
            this.loadData('tabChange');
        },
        onRefresh() {
            this.loadData('refresh');
        },
        logisticinfo(tid, logno) {
            this.$router.push({
                path: '/logisticstrajectory',
                query: {
                    tid: tid
                }
            });
        },
        onsearch(val){

            this.navList.forEach(x=>{
                x.getparams.name=val;
                x.loadingType='refresh';
            })
            
           this.loadData();
        },
        loadData(source) {
            //这里是将订单挂载到tab列表下
            let index = this.tabCurrentIndex;
            let navItem = this.navList[index];
            
            // let state = navItem.state;

            if (source === 'tabChange' && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }
            if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
                if (source != "refresh") {
                    return;
                }
            }
            if(navItem.loadingType=='refresh')
            {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            if (source === 'refresh') {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            navItem.loadingType = 'loading';
            var params = navItem.getparams;
            
            //加载数据
            request.post('/api/services/app/PhoneTrade/QueryOrder', params).then(x => {

                this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navList[index].orderList = this.navList[index].orderList.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' : 'nomore';
            }).finally(() => {
                this.navList[index].loaded = false;
                this.refreshing = false;
            });
            

        },
        godetail(item) {
            // console.log(item);
            this.$router.push({
                path: '/user/orderdetail',
                query: {
                    tid: item.tid
                }
            });
        },
        oncepay(item) {
            this.$router.push({
                path: '/pay',
                query: {
                    tid: item.tid,
                    code:''
                }
            });
        },
        sqtk(item) {
            this.paydto.tid = item.tid;
            this.$dialog.confirm({title:'您是否要申请退款'}).then(x=>
            {
                request.post('/api/services/app/PhoneRefund/BuyerRefund', this.paydto).then(() => {
                this.loadData('refresh');
                })
            })
            
        },
        cancelOrder(item) {
            this.paydto.tid = item.tid;
            this.$dialog.confirm({title:'您是否要取消订单'}).then(x=>
            {
                 request.post('/api/services/app/PhoneTrade/CancelOrder', this.paydto).then(() => {
                    //重新刷新或者替换该条数据
                    //查找两个列表将数据更换掉
                    this.loadData('refresh');
                })
            })
        },
        confirmsend(item) {
            this.paydto.tid = item.tid;
            request.post('/api/services/app/PhoneTrade/ConfirmReceiptOrder', this.paydto).then(() => {
                this.loadData('refresh');
            });
        },
         headerTouchStart(e) {
        // 固定元素滑动，浮动起来
        this.fixed = true
      },
      headerTouchMove(e) {
        // 组织默认事件，防止跳动
        e.preventDefault();
      },
      headerTouchEnd(e) {
        // 互动结束，浮动解除，防止滚动元素无法滚动
        this.fixed = false
      },
      contentTouchStart(e) {
        this.contentStartY = e.changedTouches[0].clientY;
      },
      contentTouchMove(e,index) {
        let endY = e.changedTouches[0].clientY;
        // 获取滚动的距离
        let diff = endY - this.contentStartY;
        let scrollTop = this.$refs.container[index].scrollTop
        // 如果拉到顶了还继续往下拉
        if(diff > 0 && scrollTop <= 0) {
          this.fixed = true;
          e.preventDefault();
        }else if(diff < 0){ // 如果没有拉到顶，则正常滑动内容栏
          this.fixed = false;
        }
      },
      contentTouchEnd(e) {
        this.fixed = false;
      },

    }
}
</script>

<style lang="scss" scoped>

.omheader{
    height: 36px;
    padding: 5px;
    background-color: white;
}
.omheader-info{
    position: relative;
}
.omheader-left{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    text-align: center;
}
.omheader-search{
    height: 36px;
    padding-left: 35px;
    padding-right: 75px;
}
.van-search{
    padding: 0;
    border: 1px solid #ff9369;
    border-radius: 999px;
}
.omheader-search .van-search .van-cell{
    padding: 3px 8px 3px 0;
}

.nnlist{
    position: fixed;
    left: 0;
    right: 0;
    top: 90px;
    bottom: 0;
    overflow: auto;
}

.order-item {
    font-size: 12px;
    margin: 10px 10px 10px 10px;
}

.order-item-sl{
    padding: 10px;
    background-color: white;
    border-radius: 8px;
}
.item-header{
    margin-bottom: 10px;
    min-height: 20px;
    font-size: 14px;
}
.item-header-left{
    float: left;
}
.item-header-right{
    float: right;
}
.right-tit{
    color: #ff4c04;
}
.item-list{
    margin-bottom:10px;
}
.item-price{
    font-size: 12px;
    margin-bottom: 10px;
    text-align: right;
}
.price-left{
    margin-right: 10px;
}

.title {
    border-bottom: 1px solid #e5e5e5;
}

.item-footer{
    text-align: right;
}
.item-footer .van-button{
    padding: 0px 14px 0 14px;
    height: 28px;
    margin-left: 5px;
}


.total {
    font-size: 14px;
    text-align: left;
}

.more {
    overflow-x: scroll;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin: 5px 0 5px 15px;
}

.item {
    width: 90px;
    height: 90px;
    margin-right: 10px;
    display: inline-block;

}

.item img {
    width: 100%;
}
.wrapper{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .fixed{
    position: fixed;
    left: 0;
    top: 0;
  }
</style>
